import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queuesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyQueuesDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.card-title',
		defaultMessage: 'Update priority group',
		description: 'Card title when updating an existing JSM queue group',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.confirm-button',
		defaultMessage: 'Update',
		description: 'Label for the confirm button when updating a JSM queue group',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.success-pill',
		defaultMessage: `You've updated "{name}" group`,
		description:
			'Pill message shown after update JSM queue group succeeds; name is the queue group name',
	},
	queuesLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.queues-label',
		defaultMessage: 'Following are the updated queues in this group:',
		description: 'Label for the list of queues in the update queue group card body',
	},
	emptyQueuesDescription: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue-group.empty-queues-description',
		defaultMessage: 'This group will have no queues.',
		description:
			'Message shown in the update queue group card when no queues will be assigned to the group.',
	},
});
